import { isPlatformBrowser } from "@angular/common";
import {
    AfterViewInit,
    Directive,
    ElementRef,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
} from "@angular/core";
import { Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";

import { ObserverFactory } from "@hermes/utils-generic/helpers";

type Animate = IntersectionObserverInit & { animate: boolean };

@Directive({
    selector: "[hAnimateOnScroll]",
    standalone: false,
})
export class AnimateOnScrollDirective
    implements AfterViewInit, OnDestroy, OnInit
{
    @Input()
    public hAnimateOnScroll!: Animate;

    private subscription?: Subscription;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Record<string, unknown>,
        private observerFactory: ObserverFactory,
        private templateReference: ElementRef<HTMLElement>,
    ) {}

    public ngOnInit(): void {
        if (this.hAnimateOnScroll.animate) {
            // The css class associated is in style.css level
            // to have no effect if JS is disabled
            this.templateReference.nativeElement.classList.add(
                "hide-opacity-for-animation",
            );
        }
    }

    public ngAfterViewInit(): void {
        if (
            this.hAnimateOnScroll.animate &&
            isPlatformBrowser(this.platformId)
        ) {
            this.subscription = this.observerFactory
                .observeIntersection(
                    this.templateReference.nativeElement,
                    this.hAnimateOnScroll,
                )
                .pipe(
                    filter((entry) => entry.isIntersecting),
                    tap(() =>
                        this.templateReference.nativeElement.classList.add(
                            "animation-on-scroll",
                        ),
                    ),
                )
                // Performance : instant removal of listener (animation is triggered once)
                .subscribe(() => this.subscription?.unsubscribe());
        }
    }

    public ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
